import {useContext} from 'react'

import cx from 'classnames'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MoleculeRating, {MoleculeRatingSizes} from '@s-ui/react-molecule-rating'
import {useDelayToNextFrame} from '@adv-mt/mt-hook-use-delay-to-next-frame'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const BASE_CLASS = 'mt-BannerWebToApp'
const CONTENT_CLASS = `${BASE_CLASS}-content`
const LOGO_CLASS = `${CONTENT_CLASS}Logo`
const INFO_CLASS = `${CONTENT_CLASS}Info`
const TEXT_CLASS = `${INFO_CLASS}Text`
const RATING_CLASS = `${INFO_CLASS}Rating`
const CTA_CLASS = `${BASE_CLASS}-cta`
const QR_CLASS = `${CTA_CLASS}Qr`
const BUTTON_CLASS = `${CTA_CLASS}Button`

const APP_STORE_RATING = 4.5

export default function BannerWebToApp() {
  const {domain, i18n} = useContext(Context)
  const {track: analyticsTrack} = useAnalyticsTrack()
  const delayToNextFrame = useDelayToNextFrame()
  const config = domain.get('config')

  const isMobile = config.get('isMobile')

  const hasQr = !isMobile

  const osName = config.get('osName')

  const {
    HIT_ORIGINS: hitOrigins,
    TRACKING_EVENT_NAMES: trackingEventNames,
    TRACKING_OS_NAMES: trackingOsNames
  } = config.get('tracking')
  const {DESKTOP_QR_CODE_LOGIN_PATH} = config.get('webToApp')

  const urlStaticsImages = config.get('URL_STATICS_IMAGES')
  const logoAppsUrl = config.get('LOGO_APPS_IOS_URL')
  const logoUrl = `${urlStaticsImages}${logoAppsUrl}`
  const qrUrl = `${urlStaticsImages}${DESKTOP_QR_CODE_LOGIN_PATH}`

  const baseClass = cx(BASE_CLASS, {
    [`${BASE_CLASS}--hasQr`]: hasQr
  })

  const bannerText = hasQr ? 'WEB_TO_APP.TEXT_SCAN_AND_DOWNLOAD' : 'WEB_TO_APP.TEXT_CLICK_AND_DOWNLOAD'

  const APPSFLYER_ONELINK_URL = 'https://coches.onelink.me/1823422424/b8sabjd8'

  const handleOnClick = () => {
    delayToNextFrame(() => {
      const eventData = {
        hit_origin: hitOrigins.APP_DOWNLOAD_FROM_LOGIN_MODAL,
        hit_information: trackingOsNames[osName]
      }
      analyticsTrack({event: trackingEventNames.APP_DOWNLOAD_BUTTON_CLICKED, data: eventData})
    })
  }

  return (
    <div className={baseClass}>
      <div className={CONTENT_CLASS}>
        <div className={LOGO_CLASS}>
          <AtomImage height={60} width={60} src={logoUrl} />
        </div>
        <div className={INFO_CLASS}>
          <p className={TEXT_CLASS}>{i18n.t(bannerText)}</p>
          <div className={RATING_CLASS}>
            <MoleculeRating size={MoleculeRatingSizes.SMALL} value={APP_STORE_RATING} />
          </div>
        </div>
      </div>

      <div className={CTA_CLASS}>
        {hasQr ? (
          <div className={QR_CLASS}>
            <AtomImage src={qrUrl} />
          </div>
        ) : (
          <div className={BUTTON_CLASS}>
            <AtomButton
              design={atomButtonDesigns.SOLID}
              fullWidth
              href={APPSFLYER_ONELINK_URL}
              link
              onClick={handleOnClick}
              shape={atomButtonShapes.CIRCULAR}
              size={atomButtonSizes.LARGE}
              target="_blank"
            >
              {i18n.t('WEB_TO_APP.CTA_DOWNLOAD')}
            </AtomButton>
          </div>
        )}
      </div>
    </div>
  )
}

BannerWebToApp.displayName = 'BannerWebToApp'
BannerWebToApp.propTypes = {}
